import * as z from 'zod';

import { zodDateOrString } from '../../utils';

// All of the remittance codes
// (https://singlefamily.fanniemae.com/media/31546/display)
const FannieMaeCashRemittanceCode = z.enum([
  '001',
  '002',
  '003',
  '004',
  '005',
  '022',
  '027',
  '028',
  '102',
  '106',
  '110',
  '207',
  '208',
  '309',
  '310',
  '311',
  '312',
  '313',
  '314',
  '315',
  '316',
  '317',
  '318',
  '319',
  '320',
  '322',
  '323',
  '324',
  '332',
  '333',
  '334',
  '335',
  '336',
  '337',
  '350',
  '351',
  '352',
  '353',
  '354',
  '356',
  '357',
  '358',
  '359',
  '360',
  '370',
  '410',
  '413',
  '420',
  '433',
  '435',
  '445',
  '446',
  '449',
  '450',
  '456',
  '458',
  '462',
  '463',
  '464',
  '469',
  '475',
  '478',
  '480',
  '488',
  '494',
  '495',
  '571',
  '700',
  '702',
  'MGF',
  'MPI',
  'MYM',
  'RMFGF',
  'SSCRA',
  'BU/BD',
  'MBSPI',
  'MFC&D',
  'MFCE',
  'PDFA',
  'PPFEE',
  'REVMG',
  'SFC',
  'SFGF',
  'SMP',
]);
export type FannieMaeCashRemittanceCode = z.infer<typeof FannieMaeCashRemittanceCode>;

export const FannieMaeCRSV1 = z.object({
  version: z.literal('1').describe('version'),
  lenderNumber: z.string().describe('string'),
  remittanceCode: FannieMaeCashRemittanceCode.describe('enum'),
  draftAmount: z.number().describe('currency'),
  /** fannieMaeLoanNumber is only required for CRS code 028 and 300 series */
  fannieMaeLoanNumber: z.string().optional().describe('string'),
  draftSettlementDate: zodDateOrString.optional().describe('date'),
});
export type FannieMaeCRSV1 = z.infer<typeof FannieMaeCRSV1>;

export const FannieMaeCRS = FannieMaeCRSV1;
export type FannieMaeCRS = z.infer<typeof FannieMaeCRS>;
// Make `FannieMaeCRS` a discriminated union on 'version' when changes happen
// export const FannieMaeCRSV2 = z.object({
//   version: z.literal('2'),
//   foo: z.string(),
// });
// export const FannieMaeCRS = z.discriminatedUnion('version', [FannieMaeCRSV1, FannieMaeCRSV02012025]);

export type FannieMaeCRSTotalsPerCode = Map<FannieMaeCashRemittanceCode, number>;
